module.exports = __webpack_public_path__ + "static/media/ils_covid_pending.9919c63b.svg";